<script>
    import { moneda, moneda4 } from "../scripts";


    export let factura={};

</script>


<div class="row mt-3">
    <div class="col-3 text-center mt-3">
        <p class='mb-0 lh-1'>CANTIDAD PRODUCTOS</p>
        <h5 class='lh-1 fw-bold text-success'>{factura.cantidad}</h5>
    </div>
    <div class="col-9 text-center">
        <div class='bg-light pt-2 pb-2 border border-secondary rounded'>
            <p class='mb-0 lh-1 text-center text-secondary'>TOTAL</p>
            <h1 class='lh-1 fw-bold text-success'>{moneda4(factura.total, 'Q.')}</h1>
        </div>
    </div>    
</div>

<!-- <div class='mt-2 me-1 text-end'>









</div> -->

<style>
    p {
        font-size:0.8em;
    }
    h1 {
        font-size:2.0em;
    }    
</style>